import styled, { css } from "styled-components";

import { ButtonLink } from "~/components/Button";
import CompanyLogo from "~/components/CompanyLogo";
import { size } from "~/styles/screen";
import { from } from "~/styles/theme";

interface VaspCardContainerProps {
  hasActionButton?: boolean;
  isSelected?: boolean;
  hasUpperContent?: boolean;
}
export const VaspCardContainer = styled.div<VaspCardContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 400px;
  cursor: pointer;
  cursor: ${(props) => (props.hasActionButton ? "default" : "pointer")};
  background: white;
  border-radius: 8px;
  border: ${(props) => (props.isSelected ? "2px solid #41E029" : "1px solid #e0e0e0")};
  padding: 24px;
  padding-top: ${(props) => (props.hasUpperContent ? "10px" : "24px")};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  position: relative;
  @media screen and (max-width: ${size.small}) {
    & {
      min-width: unset;
    }
  }
`;

export const MainContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

interface VASPInfoContainer {
  hasActionButton?: boolean;
}

export const VASPInfoContainer = styled.div<VASPInfoContainer>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-left: 16px;
  text-align: left;
  width: ${(props) => (props.hasActionButton ? "85%" : "100%")};
`;

export const LogoAndInfoContainer = styled.div<VASPInfoContainer>`
  display: flex;
  width: ${(props) => (props.hasActionButton ? "85%" : "calc(100% - 100px)")};
  margin-bottom: 10px;
`;

export const CallToAction = styled.div<VASPInfoContainer>`
  width: 15%;
  margin-left: 4px;
  align-self: center;
`;

export const StatusContainer = styled.div`
  display: flex;
`;

export const JurisdictionItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Title = styled.text`
  font-size: 24px;
  font-weight: 800;
  width: 100%;
  font-family: "Montserrat";
  line-height: 29px;
  color: black;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: initial;
  margin-bottom: 4px;
`;

export const Subtitle = styled.div`
  font-size: 16px;
  color: #4f4f4f;
  width: 100%;
  margin-bottom: 10px;
  line-height: 21px;
`;

export const VASPHeaderLogo = styled(CompanyLogo)`
  min-width: 60px;
  height: 60px;
  ${from.tablet(css`
    min-width: 88px;
    height: 88px;
  `)}
`;

export const ViewDetailsButton = styled(ButtonLink)`
  position: absolute;
  right: 0;
  margin-right: 30px;
  content: "View";
  visibility: visible;
  background-color: lightgrey;

  @media screen and (max-width: ${size.small}) {
    & {
      margin-right: 0;
    }
  }
`;
